import React from 'react';
import PropTypes from 'prop-types';
import RapHousieEntityTriviaCard from './RapHousieEntityTriviaCard';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import { LIVE_GAME_SECTION_TITLE_STYLE } from '../constants/housieLiveStyles';

const LiveGameTriviaPanel = ({ triviaData, title, onClick }) => {
  if (!triviaData) return null;

  const cardData = triviaData?.entity
    ? triviaData
    : triviaData?.mqtt_payload || triviaData;
  const sectionTitle =
    title || TEXT_LABELS.RAP_HOUSIE_LIVE_GAME_TRIVIA_SECTION_TITLE;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        height: '100%',
        width: '100%',
        flexDirection: 'column',
        gap: 16,
        alignItems: 'center',
        minHeight: 0,
      }}
    >
      <h2 style={LIVE_GAME_SECTION_TITLE_STYLE}>{sectionTitle}</h2>
      <RapHousieEntityTriviaCard
        variant="live"
        triviaData={cardData}
        onClick={onClick}
      />
    </div>
  );
};

LiveGameTriviaPanel.propTypes = {
  triviaData: PropTypes.object,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default LiveGameTriviaPanel;
